import api from '@api/api';
import { TranslateData } from '@customTypes/Api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useTranslateEmails = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (newOrder: TranslateData) => {
      return api.translateEmails(newOrder);
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries(['emails']);
      },
    }
  );
  return { ...mutation };
};

export default useTranslateEmails;
